"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = Icon;
const jsx_runtime_1 = require("react/jsx-runtime");
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
const class_variance_authority_1 = require("class-variance-authority");
const react_1 = require("react");
// TODO: Update after spacing & sizing is finalized.
const IconVariants = (0, class_variance_authority_1.cva)("", {
    variants: {
        size: {
            small: "ko:size-4 ko:min-w-4",
            medium: "ko:size-6 ko:min-w-6",
            large: "ko:size-8 ko:min-w-8",
        },
    },
    defaultVariants: {
        size: "medium",
    },
});
function Icon({ icon, size, title, decorative, isIcon = true, className, ...props }) {
    const titleId = (0, react_1.useId)();
    // Don't pass isIcon to DOM elements
    const { isIcon: _, ...domProps } = { isIcon, ...props };
    if (typeof icon === "string") {
        return ((0, jsx_runtime_1.jsxs)("svg", { ...domProps, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": decorative ? "true" : "false", "aria-labelledby": !decorative ? titleId : undefined, focusable: "false", role: decorative ? undefined : "img", className: (0, utilities_1.twMerge)(IconVariants({ size }), className), viewBox: "0 0 24 24", fill: "currentColor", children: [!decorative && title && (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }), (0, jsx_runtime_1.jsx)("path", { d: icon, fill: "currentColor" })] }));
    }
    const SvgIcon = icon;
    return ((0, jsx_runtime_1.jsx)(SvgIcon, { ...domProps, title: title, titleId: titleId, decorative: decorative, focusable: "false", role: decorative ? undefined : "img", "aria-labelledby": !decorative ? titleId : undefined, "aria-hidden": decorative ? "true" : "false", className: (0, utilities_1.twMerge)(IconVariants({ size }), className) }));
}
